// extracted by mini-css-extract-plugin
export const navbar = "navbar-module--navbar--1JRn8";
export const navbarNav = "navbar-module--navbar-nav--17bch";
export const logo = "navbar-module--logo--2d1J7";
export const linkIcon = "navbar-module--link-icon--1ya-I";
export const navItem = "navbar-module--nav-item--3gyFP";
export const logoText = "navbar-module--logo-text--2XIsA";
export const linkText = "navbar-module--link-text--2Er9d";
export const navLink = "navbar-module--nav-link--3akbZ";
export const activeNavLink = "navbar-module--active-nav-link--3vHTR";